
import {
  ControlElement,
  JsonFormsRendererRegistryEntry,
  withIncreasedRank,
} from '@jsonforms/core';
import { rendererProps } from '@jsonforms/vue2';
import {
  ArrayLayoutRenderer,
  arrayLayoutRendererEntry,
} from '@jsonforms/vue2-vuetify';
import { VTooltip, VIcon, VBtn } from 'vuetify/lib';
import { defineComponent } from 'vue';

const controlRenderer = defineComponent({
  name: 'custom-array-renderer',
  components: {
    ArrayLayoutRenderer,
    VTooltip,
    VIcon,
    VBtn,
  },
  props: {
    ...rendererProps<ControlElement>(),
  },
});

export default controlRenderer;

export const entry: JsonFormsRendererRegistryEntry = {
  renderer: controlRenderer,
  tester: withIncreasedRank(1, arrayLayoutRendererEntry.tester),
};
